document.addEventListener("DOMContentLoaded", function () {
    // Immediately hide the banner (even before Shopify loads)
    var cookieBanner = document.querySelector("#shopify-pc__banner");
    if (cookieBanner) {
        cookieBanner.style.display = "none";
        cookieBanner.style.visibility = "hidden";
    }

    // Fix: the old version called this every second forever on every page.
    // Now it retries until Shopify's privacy API is ready (max 15 tries), runs once, then stops.
    var tries = 0;
    function acceptCookiesShopify() {
        if (window.Shopify && Shopify.customerPrivacy && typeof Shopify.customerPrivacy.setTrackingConsent === "function") {
            Shopify.customerPrivacy.setTrackingConsent({
                analytics: true,
                marketing: true,
                preferences: true,
                sale_of_data: true
            }, function () {});
            return;
        }
        if (++tries < 15) setTimeout(acceptCookiesShopify, 1000);
    }

    acceptCookiesShopify();
});
